<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->
  <h1 class="text-gray-800">Statistics</h1>
  <!-- Page Body -->
  <div class="card shadow mb-4">
    <div class="card-body d-flex flex-row justify-content-between">
      <form action="" class="form-inline">
        <div class="form-row align-items-center">
          <div class="col-auto ml-2">
            <select
              class="form-select"
              id="thingType"
              name="thingType"
              [disabled]="dailyNewDevicesLoading"
              [formControl]="thingTypeFilter"
            >
              @for (filter of filters; track filter.id) {
                <option [value]="filter.name">{{ filter.name }}</option>
              }
            </select>
          </div>
          <div class="col-auto ml-2">
            <button class="btn btn-primary" type="button" (click)="resetFilter()">
              Reset filters
            </button>
          </div>
        </div>
      </form>
      <button class="btn btn-success" [disabled]="thingTypeSubject.value === ''" (click)="startExport()">
        <i class="fas fa-file-csv mr-2"></i>
        Manual Export
      </button>
    </div>
  </div>
  <app-tab-view>
    <app-tab tabId="stats" tabTitle="Daily New Devices">
      <ng-template #tabContent>
        <div class="card shadow mb-4">
          <div class="card-body">
            @if (!dailyNewDevicesLoading) {
              <div class="row">
                <div class="col" style="position: relative">
                  <div
                    class="Bullet-sc-ugsus7 haJNPv"
                    (click)="changeNumberOfDays(7)"
                    [ngClass]="{ active: numberOfDays === 7 }"
                  >
                    Last 7 Days
                  </div>
                  <div
                    class="Bullet-sc-ugsus7 haJNPv"
                    (click)="changeNumberOfDays(14)"
                    [ngClass]="{ active: numberOfDays === 14 }"
                  >
                    Last 14 Days
                  </div>
                  <div
                    class="Bullet-sc-ugsus7 haJNPv"
                    (click)="changeNumberOfDays(30)"
                    [ngClass]="{ active: numberOfDays === 30 }"
                  >
                    Last 30 Days
                  </div>
                  <div
                    class="Bullet-sc-ugsus7 haJNPv"
                    (click)="changeNumberOfDays(60)"
                    [ngClass]="{ active: numberOfDays === 60 }"
                  >
                    Last 60 Days
                  </div>
                  @if (dailyNewDevicesData) {
                    <canvas
                      baseChart
                      height="60"
                      [datasets]="barChartData"
                      [labels]="dailyNewDevicesData.labels"
                      [options]="barChartOptions"
                      [legend]="false"
                      type="bar"
                      class="chartjs-render-monitor"
                    >
                    </canvas>
                  }
                </div>
              </div>
            } @else {
              <div class="alert alert-primary" role="alert">Loading...</div>
            }
          </div>
        </div>
      </ng-template>
    </app-tab>
    <app-tab tabId="exports" tabTitle="Export History">
      <ng-template #tabContent>
        <app-list-exports [thingType]="(thingType$ | async) ?? undefined"></app-list-exports>
      </ng-template>
    </app-tab>
  </app-tab-view>
</div>
